import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { KakaoContactModalProvider } from "@/contexts/KakaoContactModalContext";
import { PhoneContactModalProvider } from "@/contexts/PhoneContactModalContext";
import SeoHead from "@/components/seo/SeoHead";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <KakaoContactModalProvider>
          <PhoneContactModalProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <SeoHead />
              <AppRoutes />
            </BrowserRouter>
          </PhoneContactModalProvider>
        </KakaoContactModalProvider>
      </LanguageProvider>
    </I18nextProvider>
  );
}

export default App;
